import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { Title } from "@angular/platform-browser";
import { ProfileService } from '../shared/services/profile.service';
import { IProfile } from '../shared/interfaces/profile';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  city: string;
  rawCity: string;
  state: string;
  hidden: boolean = true;
  whatsappApi: string;

  constructor(
    private route: ActivatedRoute,
    private meta: Meta,
    private titleService: Title,
    private location: Location,
    private profileService: ProfileService) {
    this.route.params.subscribe(res => {
      this.configureSite(res.city);
    });
  }

  ngOnInit(): void {
    let profile: IProfile = this.profileService.getProfile();
    this.whatsappApi = environment.whatsappApiUrl + profile.address.whatsAppNumber;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.hidden = window.pageYOffset < 150;
  }

  scrollTop() {
    document.getElementsByName("header")[0].scrollIntoView({ behavior: 'smooth' });
  }

  configureSite(city: string) {
    environment.city = city;

    this.rawCity = "sao-joao-da-boa-vista";
    this.city = "São João da Boa Vista";
    this.state = "São Paulo";
    this.location.go(`${this.rawCity}`);

    this.configureTitle();
    this.configureMetaTags();
  }

  configureTitle() {
    this.titleService.setTitle(`Dra Vanessa Lago - Pneumologista em ${this.city}, ${this.state}`);
  }

  configureMetaTags() {
    this.meta.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=1' });
    this.meta.addTag({ name: 'description', content: `Dra Vanessa Lago, médica pneumologista em ${this.city}, ${this.state}` });
    this.meta.addTag({ name: 'og:locale', content: 'pt_BR' });
    this.meta.addTag({ name: 'og:site_name', content: `Dra Vanessa Lago - Pneumologista em ${this.city}, ${this.state}` });
    this.meta.addTag({ name: "og:title", content: `Dra Vanessa Lago - Pneumologista em ${this.city}, ${this.state}` });
    this.meta.addTag({ name: "og:type", content: "website" });
    this.meta.addTag({ name: "og:url", content: "https://www.vanessalagopneumologista.com.br" });
    this.meta.addTag({ name: "og:image:url", content: `https://www.vanessalagopneumologista.com.br/assets/images/dra-vanessa-lago-pneumologista-em-${this.rawCity}.jpg` });
    this.meta.addTag({ name: "og:image:type", content: "image/jpeg" });
    this.meta.addTag({ name: "og:image:width", content: "200" });
    this.meta.addTag({ name: "og:image:height", content: "200" });
    this.meta.addTag({ name: "og:description", content: `Dra Vanessa Lago, médica pneumologista em ${this.city}, ${this.state}` });
  }

}
